import { AxiosResponse } from 'axios';
import api from './Api'

export const createAddIssuedWellnessTicketDateByAddIssuedWellnessTicketDateCreateAdminRequestAndToken = (AddIssueddWellnessTicketDateCreateAdminRequest: IAddIssuedWellnessTicketDateCreateAdminRequest) => {
    return api.post(`${process.env.REACT_APP_API_DOMAIN}/add-wellness-ticket-date/admin/v2`, AddIssueddWellnessTicketDateCreateAdminRequest);
}
export const getAllAddIssuedWellnessTicketDateByWellnessTicketId = (wellnessTicketId: string): Promise<AxiosResponse<IAddIssuedWellnessTicketDateBasicAdminResponse[], any>> => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/add-wellness-ticket-date/admin/v2/${wellnessTicketId}`)
}
